import { verifyMessage } from "ethers/lib/utils";

export default class SignerMessage {
  constructor(ethSigner) {
    this.ethSigner = ethSigner;

    this.signMessage = this.signMessage.bind(this);
    this.verifySigner = this.verifySigner.bind(this);
  }

  async signMessage(message) {
    try {
      const signature = await this.ethSigner.signMessage(message);
      return { error: null, signature: signature };
    } catch (error) {
      console.error(error);
      return { error: error, signature: null, nonce: null };
    }
  }

  verifySigner(message, signature) {
    try {
      const check = verifyMessage(message, signature);
      return { error: null, isSigner: check };
    } catch (error) {
      console.error(error);
      return { error: error, isSigner: null };
    }
  }
}
